import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { JeeMainsSession1EntryRoutingModule } from './jee-mains-session1-entry-routing.module';
import { JeeMainsSession1HltEntryComponent } from './jee-mains-session1-hlt-entry/jee-mains-session1-hlt-entry.component';
import { JeeMainsSession1HltEntryLinkComponent } from './jee-mains-session1-hlt-entry-link/jee-mains-session1-hlt-entry-link.component';
import { AgGridModule } from 'ag-grid-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatOptionModule } from '@angular/material/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { JeeMainsNotAppliedComponent } from './jee-mains-not-applied/jee-mains-not-applied.component';
import { MatDialogModule } from '@angular/material/dialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { JeeMainsSession2HltEntryComponent } from './jee-mains-session2-hlt-entry/jee-mains-session2-hlt-entry.component';
import { AcademicFormModule } from '../academic-form/academic-form.module';
import { JeeMainsSession1RookieHltEntryComponent } from './jee-mains-session1-rookie-hlt-entry/jee-mains-session1-rookie-hlt-entry.component';
import { JeeMainsRookieNotAppliedComponent } from './jee-mains-rookie-not-applied/jee-mains-rookie-not-applied.component';
import { JeeMainsSession2RookieHltEmtryComponent } from './jee-mains-session2-rookie-hlt-entry/jee-mains-session2-rookie-hlt-emtry.component';
import { NeetHltEntryComponent } from './neet-hlt-entry/neet-hlt-entry.component';
import { NeetHltNotAppliedComponent } from './neet-hlt-not-applied/neet-hlt-not-applied.component';
import { NeeRookieHltEntryComponent } from './nee-rookie-hlt-entry/nee-rookie-hlt-entry.component';
import { NeetRookieNotAppliedComponent } from './neet-rookie-not-applied/neet-rookie-not-applied.component';



ReactiveFormsModule
FormsModule



@NgModule({
  declarations: [
    JeeMainsSession1HltEntryComponent,
    JeeMainsSession1HltEntryLinkComponent,
    JeeMainsNotAppliedComponent,
    JeeMainsSession2HltEntryComponent,
    JeeMainsSession1RookieHltEntryComponent,
    JeeMainsRookieNotAppliedComponent,
    JeeMainsSession2RookieHltEmtryComponent,
    NeetHltEntryComponent,
    NeetHltNotAppliedComponent,
    NeeRookieHltEntryComponent,
    NeetRookieNotAppliedComponent,
   
  ],
  imports: [
    CommonModule,
    AcademicFormModule,
    JeeMainsSession1EntryRoutingModule,
    AgGridModule,
    NgxSpinnerModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatOptionModule,
    MatAutocompleteModule,
    MatDialogModule,
    BrowserAnimationsModule,
   
    
    
    
  ]
})
export class JeeMainsSession1EntryModule { }
